module.exports = __webpack_public_path__ + "1de392029c2ec2e0b6264ec22b5d85.ttf";